<div id="file-list">
  <span class="empty" *ngIf="isAllowedEmpty">
    <button (click)="onSelectedFile(empty)">画像なし</button>
  </span>
  <span *ngFor="let file of images" class="image">
    <img *ngIf="0 < file.url.length" [src]="file.url | safe: 'resourceUrl'" [alt]="file.name" height="120" (click)="onSelectedFile(file)">
    <img *ngIf="file.url.length <= 0" src="./assets/images/loading.gif" alt="{{file.name}}">
  </span>
</div>